<template>
  <user-requests
    v-if="requests"
    :first_name="dataUser.first_name"
    :last_name="dataUser.last_name"
    :requests="requests"
    @done="done"
    @rich-bottom="richBottom"
  />
</template>

<script>
import userRequests from '@/components/lists/users/userRequests'
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
    props: {
        dataUser: {
            required: true,
        },
    },
    components: {
        userRequests,
    },
    computed: {
        ...mapGetters({
            requests: 'specialists/specialistRequests',
            isLastPage: 'specialists/isLastPage',
        }),
    },
    methods: {
        ...mapMutations({
            incSpecialistCurrentPage: 'specialists/incSpecialistCurrentPage',
            setRequests: 'specialists/setRequests',
            addRequests: 'specialists/addRequests',
            resetRequestsPage: 'specialists/resetRequestsPage',
        }),
        ...mapActions({
            getSpecialistRequests: 'specialists/getSpecialistRequests',
        }),
        async done() {
            this.resetRequestsPage()
            const response = await this.getSpecialistRequests(this.dataUser.id)
            this.setRequests(response)
        },
        async richBottom() {
            if (this.isLastPage) {
                return
            }

            this.incSpecialistCurrentPage()
            const response = await this.getSpecialistRequests(this.dataUser.id)
            this.addRequests(response)
        },
    },
    async created() {
        this.resetRequestsPage()
        const response = await this.getSpecialistRequests(this.dataUser.id)
        this.setRequests(response)
    },
}
</script>

<style lang="scss" scoped>
.master {
  &-name {
    border-top: 1px solid lightgrey;
    margin-top: 20px;
    padding-top: 10px;
    margin-bottom: 10px;
    color: #4d4d4d;
    font-family: "SFUIDisplay-Regular";
    font-size: 18px;
  }

  &-comments {
    width: 100%;
    max-height: 70vh;
    overflow-y: auto;
  }

  &-comment {
    display: flex;
    padding: 6px 0;
    width: 100%;

    &:nth-child(odd) {
      background-color: #f8f5f5;
    }

    &__rate {
      width: 11%;
      text-align: center;
    }

    &__status {
      width: 20%;
    }

    &__comments {
      width: 70%;
      box-sizing: border-box;
      padding-left: 5%;
    }

    &__link {
      width: 20%;
    }
  }
}
</style>
